import { PageHero } from "../components/site/PageHero";
import { CtaBanner } from "../components/site/CtaBanner";
import { Reveal } from "../components/site/Reveal";
import { ECOSYSTEM_CARDS } from "../components/home/EcosystemSection";
import { Seo } from "../components/site/Seo";

export default function Ecosystem() {
  return (
    <main data-testid="ecosystem-page">
      <Seo
        title="The MST Ecosystem | Multiple Stream Team"
        description="Five interconnected pillars — business & investments, education, collaboration, resources, and community impact — power the MST ecosystem."
        path="/ecosystem"
      />
      <PageHero
        label="The MST Ecosystem"
        title={<>Multiple Streams. <span className="text-[#009BFF]">Endless Opportunities.</span></>}
        text="Five interconnected pillars power the MST ecosystem — each designed to help members build, collaborate, and create multiple streams of income together."
      />
      <section className="bg-[#041525] py-24">
        <div className="max-w-6xl mx-auto px-6 lg:px-8 space-y-8">
          {ECOSYSTEM_CARDS.map(({ Icon, title, text }, i) => (
            <Reveal
              key={title}
              delay={i * 0.06}
              data-testid={`ecosystem-pillar-${i}`}
              className="rounded-2xl border border-[#006FD6]/25 bg-gradient-to-r from-[#062541] to-[#041525] p-8 sm:p-10 flex flex-col sm:flex-row items-start gap-7 hover:border-[#009BFF]/50 hover:shadow-[0_0_30px_rgba(0,196,244,0.15)] transition-[border-color,box-shadow] duration-300"
            >
              <div className="flex items-center gap-5 shrink-0">
                <span className="text-2xl font-extrabold text-white/15" style={{ fontFamily: "var(--font-heading)" }}>
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="w-14 h-14 rounded-xl bg-[#009BFF]/10 border border-[#009BFF]/30 flex items-center justify-center">
                  <Icon size={26} strokeWidth={1.5} className="text-[#00C4F4]" />
                </div>
              </div>
              <div>
                <h3 className="text-xl font-extrabold text-white" style={{ fontFamily: "var(--font-heading)" }}>{title}</h3>
                <p className="mt-3 text-[#B7C0CC] leading-relaxed max-w-2xl">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <CtaBanner />
    </main>
  );
}
